import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripManifestComponent } from './trip-manifest/trip-manifest.component';
import {TripManifestService} from './trip-manifest.service';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {AgGridModule} from 'ag-grid-angular';
import {ApprovalTripModule} from '../../trip-reservations/approval-trip/approval-trip.module';

@NgModule({
  imports: [
    CommonModule,
    Trip2ThemeModule,
    AgGridModule,
    ApprovalTripModule
  ],
  exports: [
    TripManifestComponent
  ],
  declarations: [TripManifestComponent],
  providers: [TripManifestService]
})
export class TripManifestModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/trip-manifest/trip-manifest.module.ts